import React from 'react';
import { Box } from '@razorpay/blade/components';
import { WizardInfoProvider } from 'components/WizardViews/providers';
import { WizardHeader, WizardWrapper } from 'components/WizardViews/components';
import { useHistory } from 'react-router-dom';
import { routePaths } from 'components/Routes/data';
import { AccountDetailsStep } from './AccountDetailsStep';
import { useFormWithProvider } from 'forms';
import { useUserId } from '../hooks/useUserId';
import { BankAccountFormData } from './types';
import { bankFormDataInitialState } from '../data';
import { useGetBankAccountDetails } from '../hooks/useGetBankAccountDetails';

export const AddEditBankAccount = () => {
  const history = useHistory();
  const userId = useUserId();
  const { setFormData } = useFormWithProvider<BankAccountFormData>();

  const employeeName =
    useGetBankAccountDetails().queryResponse.data?.data.meta
      ?.employee_name ?? '';

  const handleCloseClick = () => {
    history.push({
      pathname: routePaths.employeeDetailsV2.bankAccountDetails.preview,
      search: `?userId=${userId}`,
    });
    setFormData(bankFormDataInitialState);
  };

  const moveToPreview = () => {
    history.push({
      pathname: routePaths.employeeDetailsV2.bankAccountDetails.preview,
      search: `?userId=${userId}`,
    });
    setFormData(bankFormDataInitialState);
  };

  return (
    <WizardInfoProvider initialStep={1} totalSteps={1}>
      <WizardWrapper>
        <WizardHeader heading="Add" subHeading="Bank Account" onCloseClick={handleCloseClick} />
        <Box width="100%" flex={1} overflowY="auto" height="100%">
          <AccountDetailsStep onSuccess={moveToPreview} employeeName={employeeName} />
        </Box>
      </WizardWrapper>
    </WizardInfoProvider>
  );
};
